import './App.css';
import ExceptionHandler from './shared/exceptionHandler/exceptionHandler';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify'; //NOSONAR
import 'react-toastify/dist/ReactToastify.css'; //NOSONAR
import { useConfiguration } from './hooks/useConfiguration';
import ConfigurationProvider from './providers/ConfigurationProvider';
import { AuthenticationProvider } from '@axa-fr/react-oidc-context';
import FullScreenLoading from './features/common/FullScreenLoading';
import PostAuthentication from './PostAuthentication';
import { getDateFormat } from '../src/features/common/Common.utils';
import SessionLost from './features/common/SessionLost';
import { PORTAL_DIV_ID } from './features/common/Common.constants';

export default function App() {
  const { config, isHavingSetupErr } = useConfiguration();
  const [translate] = useTranslation();
  localStorage.setItem('DateFormat', getDateFormat());

  if (isHavingSetupErr) {
    return (
      <div className="w-screen h-screen flex flex-col items-center justify-center">
        <div className="text-md text-red-400 mt-3" role="text-area-err-msg">
          {translate('INITIALIZING_ERROR')}
        </div>
      </div>
    );
  }

  if (!config) {
    return <FullScreenLoading />;
  }

  return (
    <ConfigurationProvider config={config}>
      <AuthenticationProvider
        configuration={config.OIDC_CONFIGURATION}
        isEnabled={true}
        authenticating={FullScreenLoading}
        callbackComponentOverride={FullScreenLoading}
        sessionLostComponent={SessionLost}
      >
        <ExceptionHandler>
          <ToastContainer
            position="bottom-center"
            autoClose={config.TOAST_AUTOCLOSE_INTERVAL}
            pauseOnHover
          />
          <PostAuthentication config={config} />
          <div id={PORTAL_DIV_ID} />
        </ExceptionHandler>
      </AuthenticationProvider>
    </ConfigurationProvider>
  );
}
